module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightrain-2c16ff3cdd051908c1c8fa047ae445e6.png";